import * as z from "zod";

export const geocodeTrackingMapLocation = {
  name: "geocodeTrackingMapLocation" as const,
  input: z.object({
    city: z.string().nullish(),
    state: z.string().nullish(),
    country: z.string().nullish(),
    postalCode: z.string().nullish(),
  }),
  output: z.object({
    geo: z.object({ latitude: z.number(), longitude: z.number() }).nullable(),
  }),
};
